import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="auth-layout">
      <Outlet /> {/* This is where child components will be rendered */}
    </div>
  );
};

export default AuthLayout;
